import BetasiNewsletter from "./BetasiNewsletter";
import ZuuInternal from "./ZuuInternal/ZuuInternal";
import NfHotel from "./NfHotel";

export default {
    "betasi-newsletter": BetasiNewsletter,
    "zuu-internal": ZuuInternal,
    nfhotel: NfHotel,
};
